import { FileCode2, FileText, Globe, Image as ImageIcon } from "lucide-react";
import type { DockKindDef } from "../../registry";
import { ArtifactPanel } from "./ArtifactPanel";
import { ArtifactToolbar } from "./ArtifactToolbar";
import { artifactData } from "./data";

export { artifactData, artifactPanel, type ArtifactData } from "./data";

/** Tab glyph by language — lets you find a document in a full strip without
 *  reading every truncated label. Textless SVGs, so the glyph never joins the
 *  tab's accessible name. */
function tabIconFor(language: string) {
	const lang = (language || "").toLowerCase();
	if (lang === "html" || lang === "htm" || lang === "xml") return <Globe size={13} />;
	if (lang === "svg") return <ImageIcon size={13} />;
	if (lang === "markdown" || lang === "md") return <FileText size={13} />;
	return <FileCode2 size={13} />;
}

/** The artifact kind — the first thing to plug into the dock, and the proof that
 *  the seam holds: adding it touched the registry's map and nothing else in the
 *  host. Its name and rail glyph live in DOCK_KIND_CATALOG, not here: the rail
 *  must be able to name a kind that has no Body yet. */
export const artifactKind: DockKindDef = {
	tabIcon: (panel) => tabIconFor(artifactData(panel).language),
	Body: ArtifactPanel,
	Toolbar: ArtifactToolbar,
};
